/* Cartas que me faltan — wishlist client-side (sin login).
   Guarda cartas en localStorage, inyecta el corazón en tarjetas y ficha,
   lleva el contador del header y arma la página de lista con precio/stock
   EN VIVO (product.js): marca "¡Bajó de precio!" y "¡Disponible!". */
(function () {
  'use strict';
  var KEY = 'tcgWishlist:v1';
  var SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} broadcast(); }
  function has(handle) { return read().some(function (x) { return x.handle === handle; }); }
  function broadcast() { document.dispatchEvent(new CustomEvent('tcg:wishlist')); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function copHandle(url) { var m = String(url || '').split('?')[0].match(/\/products\/([^\/]+)$/); return m ? m[1] : null; }
  function parsePrecio(t) { var s = String(t || '').replace(/[^0-9.,]/g, ''); if (!s) return null; var n = parseFloat(s.replace(/\./g, '').replace(',', '.')); return isFinite(n) ? Math.round(n) : null; }
  function fmt(cop) { try { return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(cop); } catch (e) { return '$' + cop; } }

  function toggle(item) {
    var list = read();
    var i = list.map(function (x) { return x.handle; }).indexOf(item.handle);
    if (i >= 0) { list.splice(i, 1); write(list); return false; }
    list.unshift(item); write(list.slice(0, 200)); return true;
  }

  /* ---------- botón corazón ---------- */
  function boton(handle, extra) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tcg-wish' + (extra || '');
    b.setAttribute('aria-label', 'Guardar en mi lista');
    b.innerHTML = SVG;
    if (has(handle)) b.classList.add('is-on');
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var on = toggle(b._item);
      b.classList.toggle('is-on', on);
      b.classList.add('is-pop');
      setTimeout(function () { b.classList.remove('is-pop'); }, 300);
    });
    return b;
  }

  /* ---------- inyección en tarjetas de producto ---------- */
  function marcaTarjetas(scope) {
    var cards = (scope || document).querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('.tcg-wish')) continue;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var handle = copHandle(link.getAttribute('href'));
      if (!handle) continue;
      var img = card.querySelector('img');
      var priceEl = card.querySelector('.price-item, .price__regular .price-item');
      var b = boton(handle, ' tcg-wish--card');
      b._item = {
        handle: handle,
        title: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 120),
        img: img ? (img.currentSrc || img.src) : '',
        price: priceEl ? parsePrecio(priceEl.textContent) : null,
        at: Date.now()
      };
      var media = card.querySelector('.card__media, .media') || card;
      // No tocar la posición si ya es un contexto (Crave usa position:absolute
      // en .card__media para el relleno con aspect-ratio; sobrescribirla rompe
      // el layout y deja un hueco). Solo forzar relative si es 'static'.
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      media.appendChild(b);
    }
  }

  /* ---------- inyección en la ficha de producto ---------- */
  function marcaProducto() {
    var info = document.querySelector('.product__info-container, .product-form');
    if (!info || document.querySelector('.tcg-wish--pdp')) return;
    var handle = copHandle(window.location.pathname);
    if (!handle) return;
    var titleEl = document.querySelector('.tcg-phead__name, .product__title h1, .product__title');
    var img = document.querySelector('.product__media img, .product-media-container img');
    var priceEl = document.querySelector('.price .price-item, .price-item--regular');
    var wrap = document.createElement('div');
    wrap.className = 'tcg-wish-pdp';
    var b = boton(handle, ' tcg-wish--pdp');
    b._item = {
      handle: handle,
      title: titleEl ? titleEl.textContent.trim().slice(0, 120) : handle,
      img: img ? (img.currentSrc || img.src) : '',
      price: priceEl ? parsePrecio(priceEl.textContent) : null,
      at: Date.now()
    };
    var label = document.createElement('span');
    label.className = 'tcg-wish-pdp__label';
    // Con el texto visible dentro, el nombre accesible lo da el propio texto
    // (un aria-label fijo decía "Guardar" aunque ya estuviera guardada).
    b.removeAttribute('aria-label');
    var sync = function () {
      var on = b.classList.contains('is-on');
      label.textContent = on ? 'Guardada' : 'Guardar';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    };
    b.addEventListener('click', function () { setTimeout(sync, 0); });
    sync();
    // El texto va DENTRO del botón: antes el corazón era un botón de 46px y
    // "Guardar en mi lista" un texto suelto al lado, que no se podía pulsar y
    // no medía lo mismo que "La tengo".
    b.appendChild(label);
    wrap.appendChild(b);
    var buyForm = document.querySelector('.product-form');
    if (buyForm && buyForm.parentNode) buyForm.parentNode.insertBefore(wrap, buyForm.nextSibling);
    else info.appendChild(wrap);
  }

  /* ---------- contador del header ---------- */
  function pintaBadge() {
    var n = read().length;
    var links = document.querySelectorAll('[data-tcg-wish-count]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('data-count', n);
      links[i].classList.toggle('has-items', n > 0);
    }
  }

  /* ---------- página de lista (con precio/stock en vivo) ---------- */
  function pintaPagina() {
    var root = document.querySelector('[data-tcg-wishlist]');
    if (!root) return;
    var cont = root.querySelector('[data-wish-list]');
    var vacio = root.querySelector('[data-wish-empty]');
    var list = read();
    if (!list.length) { cont.innerHTML = ''; vacio.hidden = false; return; }
    vacio.hidden = true;
    cont.innerHTML = list.map(function (it) {
      return '<article class="tcg-wishcard" data-h="' + esc(it.handle) + '">' +
        '<a class="tcg-wishcard__media" href="/products/' + esc(it.handle) + '">' +
          (it.img ? '<img src="' + esc(it.img) + '" alt="' + esc(it.title) + '" loading="lazy">' : '<span></span>') +
        '</a>' +
        '<div class="tcg-wishcard__body">' +
          '<a class="tcg-wishcard__name" href="/products/' + esc(it.handle) + '">' + esc(it.title) + '</a>' +
          '<div class="tcg-wishcard__badges" data-badges></div>' +
          '<div class="tcg-wishcard__price" data-price>' + (it.price ? fmt(it.price) : '') + '</div>' +
          '<div class="tcg-wishcard__actions">' +
            '<button type="button" class="tcg-wishcard__add" data-add disabled>Ver stock…</button>' +
            '<button type="button" class="tcg-wishcard__rm" data-rm aria-label="Quitar de la lista">Quitar</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    // Enriquecer cada tarjeta con precio y stock EN VIVO
    list.forEach(function (it) {
      var el = cont.querySelector('[data-h="' + CSS.escape(it.handle) + '"]');
      if (!el) return;
      fetch('/products/' + encodeURIComponent(it.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
          var precioAhora = v ? Math.round(v.price / 100) : null;
          var disponible = !!(v && v.available);
          var badges = [];
          if (disponible) badges.push('<span class="tcg-badge tcg-badge--ok">Disponible</span>');
          else badges.push('<span class="tcg-badge tcg-badge--out">Agotado</span>');
          if (precioAhora != null && it.price && precioAhora < it.price) {
            var baja = Math.round((1 - precioAhora / it.price) * 100);
            badges.push('<span class="tcg-badge tcg-badge--drop">¡Bajó ' + baja + '%!</span>');
          }
          el.querySelector('[data-badges]').innerHTML = badges.join('');
          if (precioAhora != null) el.querySelector('[data-price]').textContent = fmt(precioAhora);
          var add = el.querySelector('[data-add]');
          if (disponible && v) {
            add.disabled = false; add.textContent = 'Agregar al carrito';
            add.addEventListener('click', function () {
              add.disabled = true; add.textContent = 'Agregando…';
              tcgAddToCart({ id: v.id })
                .then(function () { add.textContent = 'En el carrito ✔'; add.classList.add('is-ok'); })
                .catch(function (err) {
                  if (window.tcgCartToast) tcgCartToast(err && err.message);
                  add.disabled = false; add.textContent = 'Agregar al carrito';
                });
            });
          } else { add.textContent = 'Avísame cuando vuelva'; add.classList.add('tcg-wishcard__add--soft'); add.disabled = true; add.title = 'Vuelve a revisar tu lista; te mostramos aquí cuando regrese al stock.'; }
        })
        .catch(function () {
          var add = el.querySelector('[data-add]'); if (add) { add.textContent = 'Ver carta'; add.disabled = false; add.addEventListener('click', function () { window.location.href = '/products/' + it.handle; }); }
        });
      el.querySelector('[data-rm]').addEventListener('click', function () {
        var l = read().filter(function (x) { return x.handle !== it.handle; });
        write(l); el.remove();
        if (!read().length) { vacio.hidden = false; }
      });
    });
  }

  /* ---------- init ---------- */
  function init() {
    try { marcaTarjetas(document); } catch (e) {}
    try { marcaProducto(); } catch (e) {}
    pintaBadge();
    pintaPagina();
  }
  document.addEventListener('tcg:wishlist', function () { pintaBadge(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // tarjetas que llegan por AJAX (paginación, filtros, quick view)
  new MutationObserver(function (muts) {
    var add = false;
    muts.forEach(function (m) { if (m.addedNodes && m.addedNodes.length) add = true; });
    if (add) { clearTimeout(init._t); init._t = setTimeout(function () { try { marcaTarjetas(document); } catch (e) {} }, 200); }
  }).observe(document.body, { childList: true, subtree: true });
})();
